import { Component, Input } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeListModule } from 'se-fe-list'
import { SeFeListItemSkeletonComponent } from 'se-fe-list/skeleton'

const DEFAULT_ROW_COUNT = 1

@Component({
  selector: 'se-po-profile-credentials-skeleton',
  standalone: true,
  imports: [
    SeFeCardModule,
    SeFeCardHeaderSkeletonComponent,
    SeFeListModule,
    SeFeListItemSkeletonComponent,
  ],
  template: `
    @if (inline) {
      <se-fe-list>
        @for (row of rows; track $index) {
          <se-fe-list-item-skeleton
            seFeDataSize="xsmall"
            seFeDataVisual="avatar|300"
            [seFeDataSubtitle]="true"
            [seFeDataTitle]="true">
          </se-fe-list-item-skeleton>
        }
      </se-fe-list>
    } @else {
      <se-fe-card>
        <se-fe-card-header-skeleton
          seFeDataSize="section"
          [seFeDataHeavyBorder]="true"
          [seFeDataTitle]="true">
        </se-fe-card-header-skeleton>
        <se-fe-card-content>
          <se-fe-list>
            @for (row of rows; track $index) {
              <se-fe-list-item-skeleton
                seFeDataSize="xsmall"
                seFeDataVisual="avatar|300"
                [seFeDataSubtitle]="true"
                [seFeDataTitle]="true">
              </se-fe-list-item-skeleton>
            }
          </se-fe-list>
        </se-fe-card-content>
      </se-fe-card>
    }
  `,
})
export class ProfileCredentialsSkeletonComponent {
  public rows = this.createRows(DEFAULT_ROW_COUNT)
  @Input() public inline = false

  @Input() public set count(value: number) {
    this.rows = this.createRows(value)
  }

  private createRows(count: number): number[] {
    return Array.from({ length: Math.max(0, Math.floor(count)) })
  }
}
